import { Defaults } from 'es-decorators'
import { View } from 'es6/components/view'
import 'es6/libs/countdown'
import { getTemplate } from 'helpers/template-helper'
import Backbone from 'init/backbone'
import moment from 'moment'

/**
 * Вид для флагов в рекомендациях
 */
@Defaults({
  el: '.flags',
})
export class RecommendationsFlagsView extends View {
  /**
   * @inheritDoc
   */
  run () {
    this.template = getTemplate('.product-flags-template')
    this.startTimer()
    this.listenTo(Backbone, 'modifier-click', this.setModel)
  }

  /**
   * Устанавливает текущую модель
   * @param {Item} model
   */
  setModel (model) {
    this.model = model
    this.render()
  }

  /**
   * @inheritDoc
   */
  render () {
    this.$el.html(this.template({
      model: this.model.toJSON(),
      moment: moment,
    }))
    this.startTimer()
  }

  /**
   * Запускает таймер
   */
  startTimer () {
    let $time = this.$('time')

    $time.countdown(new Date($time.attr('data-date')), event => {
      this.$('.days', $time).html(event.strftime('%D'))
      this.$('.hours', $time).html(event.strftime('%H'))
      this.$('.minutes', $time).html(event.strftime('%M'))
      this.$('.seconds', $time).html(event.strftime('%S'))
    })
  }
}
